import { QuestionAnswerOutlined } from '@material-ui/icons';
import React from 'react';

const QuestionIcon = ({ color }) => <QuestionAnswerOutlined style={{ color }} />;

export default QuestionIcon;
